export const listRatePlans = `
   query listRatePlans($filter: RatePlansFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listRatePlans(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              name
              billableUnit
              billablePeriod
              chargeTiers {
                lowerBand
                upperBand
                rate
              }
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getRatePlan = `
   query getRatePlan($id:ID!) {
       getRatePlan(id:$id) {
         id
         name
         billableUnit
         billablePeriod
         chargeTiers {
           lowerBand
           upperBand
           rate
         } 
         createdByUsername
         createdByUser {
           name
           givenName
           familyName
           email
         }
         created
         updated
       } 
}`;
